import SeoHead from '../../components/feature/SeoHead';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Desguace en Badalona – Compra de Coches',
  description: 'Compramos coches en Badalona al mejor precio. Siniestrados, averiados, sin ITV. Recogida gratuita y pago inmediato.',
  provider: {
    '@type': 'AutoDealer',
    name: 'Desguace Barcelona',
    telephone: '+34932932913',
    address: { '@type': 'PostalAddress', addressLocality: 'Badalona', addressRegion: 'Cataluña', addressCountry: 'ES' },
  },
  areaServed: { '@type': 'City', name: 'Badalona' },
  url: `${siteUrl}/desguace-badalona`,
};

export default function DesguaceBadalonaPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Desguace en Badalona | Vende tu Coche al Mejor Precio | Recogida Gratis"
        description="Desguace en Badalona. Compramos coches siniestrados, averiados o sin ITV al mejor precio. Recogida gratuita en toda Badalona y pago inmediato. Llámanos: 932 932 913."
        keywords="desguace Badalona, vender coche Badalona, compra coches Badalona, coche siniestrado Badalona, desguace cerca Badalona"
        canonical={`${siteUrl}/desguace-badalona`}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1a2332] to-[#2d3e50]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
              Desguace en Badalona
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Compramos tu coche en Badalona y alrededores. Recogida gratuita a domicilio y pago al momento.
            </p>
          </div>
        </section>

        {/* Contenido Principal */}
        <article className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            
            <div className="prose prose-lg max-w-none mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                <strong>Desguace Badalona</strong> ofrece el mejor servicio de compra de vehículos en la tercera ciudad más grande de Cataluña. Si vives en Badalona y quieres vender tu coche, somos tu mejor opción. Ofrecemos recogida gratuita en toda la ciudad y pago inmediato.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Llevamos más de <strong>15 años comprando coches en Badalona</strong> y conocemos perfectamente la zona. Desde el centro hasta los barrios de Llefià, La Salut, Sant Roc, Artigues o Montigalà, llegamos a cualquier punto de la ciudad.
              </p>
            </div>

            {/* Zonas de Badalona */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Zonas de Badalona Donde Recogemos
              </h2>
              
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
                {['Centro', 'Llefià', 'La Salut', 'Sant Roc', 'Artigues', 'Montigalà', 'Gorg', 'Casagemes', 'Canyet', 'Pomar', 'Bufalà', 'Morera'].map((zona) => (
                  <div key={zona} className="bg-[#f8f9fa] p-4 rounded-lg text-center">
                    <i className="ri-map-pin-line text-[#ff6b35] text-xl mb-2"></i>
                    <p className="text-sm font-medium text-[#1a2332]">{zona}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Ventajas */}
            <section className="mb-16">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                ¿Por Qué Elegirnos en Badalona?
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-map-pin-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Conocemos Badalona</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Años de experiencia en la zona nos permiten ofrecer un servicio rápido y eficiente.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-time-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Recogida en 24-48h</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Coordinamos la recogida de tu vehículo en el menor tiempo posible.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-money-euro-circle-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">Pago Inmediato</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Recibes el dinero en el momento de la recogida. Sin esperas ni complicaciones.
                  </p>
                </div>

                <div className="bg-[#f8f9fa] p-6 rounded-xl">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center mb-4">
                    <i className="ri-shield-check-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-3">100% Legal</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Gestionamos todos los trámites: baja en DGT, certificado de destrucción y más.
                  </p>
                </div>
              </div>
            </section>

            {/* Tipos de coches */}
            <section className="mb-16 bg-[#f8f9fa] p-8 rounded-2xl">
              <h2 className="text-3xl font-black text-[#1a2332] mb-6">
                Compramos Todo Tipo de Coches en Badalona
              </h2>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Coches siniestrados:</strong> Accidentes de tráfico, siniestro total, daños graves.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Coches averiados:</strong> Motor, caja de cambios, sistema eléctrico, cualquier avería.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Coches sin ITV:</strong> ITV caducada o vehículos que no pasan la inspección.</p>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ff6b35] text-2xl flex-shrink-0"></i>
                  <p className="text-gray-700"><strong>Coches antiguos:</strong> Vehículos viejos, con muchos km o en desuso.</p>
                </div>
              </div>
            </section>

            {/* CTA Final */}
            <section className="bg-gradient-to-br from-[#1a2332] to-[#2d3e50] rounded-2xl p-12 text-center text-white">
              <h2 className="text-4xl font-black mb-4">
                Vende tu Coche en Badalona Hoy
              </h2>
              <p className="text-xl mb-8 text-white/90">
                Tasación gratuita y sin compromiso
              </p>
              <a 
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20valorar%20mi%20coche%20en%20Badalona" 
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center px-10 py-5 bg-[#25d366] text-white rounded-full font-bold text-lg hover:bg-[#1da851] transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-3 text-2xl"></i>
                WhatsApp 932 932 913
              </a>
            </section>

          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
